import {
    WebAuth,
    Auth0DecodedHash,
    Auth0Error,
    Auth0UserProfile,
} from "auth0-js"
import { History } from "history"

let _idToken: string | undefined
let _accessToken: string | undefined
let _expiresAt: number | undefined

export type Role = "admin" | "buyer"

export default class Auth {
    private _role: Role | undefined
    private _organization: string | undefined

    auth: WebAuth
    history: History
    requestedScopes: string
    userProfile: Auth0UserProfile | null
    constructor(history: History) {
        this.userProfile = null
        this.history = history
        this.requestedScopes = "openid profile email"
        this.auth = new WebAuth({
            domain: process.env.REACT_APP_AUTH0_DOMAIN,
            clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
            redirectUri: `${process.env.REACT_APP_BASE_URL}/callback`,
            responseType: "token id_token",
            scope: this.requestedScopes,
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        })
    }

    login = () => {
        this.auth.authorize()
    }

    handleAuthentication = () => {
        this.auth.parseHash((err, authResult) => {
            if (authResult && authResult.accessToken && authResult.idToken) {
                this.setSession(authResult)
                this.history.push(`/organization`)
            } else if (err) {
                this.history.push("/")
                console.log(err)
            }
        })
    }

    setSession = (authResult: Auth0DecodedHash) => {
        _expiresAt =
            authResult.expiresIn &&
            authResult.expiresIn * 1000 + new Date().getTime()

        // _scopes = authResult.scope || this.requestedScopes || ""

        _accessToken = authResult.accessToken
        _idToken = authResult.idToken
        this._role =
            authResult.idTokenPayload[
                `${process.env.REACT_APP_AUTH0_NAMESPACE}role`
            ]
        this._organization =
            authResult.idTokenPayload[
                `${process.env.REACT_APP_AUTH0_NAMESPACE}organization`
            ]
        this.scheduleTokenRenewal()
    }

    isAuthenticated = () => {
        return _expiresAt && new Date().getTime() < _expiresAt
    }

    logout = () => {
        this.auth.logout({
            clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
            returnTo: process.env.REACT_APP_BASE_URL,
        })
        _accessToken = undefined
        _idToken = undefined
    }

    getAccessToken = () => {
        if (!_accessToken) {
            throw new Error("Access token cant be found")
        }
        return _accessToken
    }

    getIdToken = () => {
        if (!_idToken) {
            throw new Error("ID token cant be found")
        }
        return _idToken
    }

    getProfile = (
        cb: (profile: Auth0UserProfile & any, err?: Auth0Error | null) => void
    ) => {
        if (this.userProfile) return cb(this.userProfile)
        this.auth.client.userInfo(this.getAccessToken(), (err, profile) => {
            if (profile) this.userProfile = profile
            cb(profile, err)
        })
    }

    get role(): Role | undefined {
        return this._role
    }

    get organization(): string | undefined {
        return this._organization
    }
    renewToken(cb?: (error?: Auth0Error | null, result?: any) => void) {
        this.auth.checkSession({}, (err, result) => {
            if (err) {
                console.log(`Error: ${err.error} - ${err.error_description}`)
            } else {
                this.setSession(result)
            }
            if (cb) cb(err, result)
        })
    }

    scheduleTokenRenewal() {
        const delay = _expiresAt && _expiresAt - Date.now()
        if (delay && delay > 0) setTimeout(() => this.renewToken(), delay)
    }
}
